module.exports = __webpack_public_path__ + "static/02-87ffcb132f22aa46fbdcb791fe6521a7.jpg";